export default __webpack_public_path__ + "static/media/BasicGatesImg.64176a7a.jpg";